import {
  ProviderRegistrationProfessionalCredentialsInner,
  ProviderRegistrationProfessionalCredentialsInnerTypeEnum,
} from "@asd/customer-portal-api";
import { Box, Checkbox, FormControlLabel, Stack } from "@mui/material";

import { CREDENTIAL_OPTIONS } from "~/utils/providerRegistrationHelpers";
import CheckboxWithText from "./shared/CheckboxWithText";
import FieldError from "./shared/FieldError";
import useExclusiveOption from "./shared/useExclusiveOption";

interface CredentialsEditProps {
  value: ProviderRegistrationProfessionalCredentialsInner[];
  onChange: (_val: ProviderRegistrationProfessionalCredentialsInner[]) => void;
  error?: string;
}

const CredentialsEdit = ({ value = [], onChange, error }: CredentialsEditProps) => {
  const naKey = ProviderRegistrationProfessionalCredentialsInnerTypeEnum.not_applicable;
  const { isExclusiveSelected: isNASelected, isAnyNonExclusiveSelected: isAnyNonNASelected } = useExclusiveOption(
    value.map((v) => v.type),
    naKey,
  );

  return (
    <Stack direction="column">
      {CREDENTIAL_OPTIONS.map(([enumValue, label]) => {
        const existing = value.find((v) => v.type === enumValue);
        const isThisNA = enumValue === naKey;
        const isThisOther = enumValue === ProviderRegistrationProfessionalCredentialsInnerTypeEnum.other;
        const isOtherActive = typeof existing?.otherText === "string";
        const isDisabled = (isNASelected && !isThisNA) || (isAnyNonNASelected && isThisNA);

        if (isThisOther) {
          return (
            <Box key={enumValue} sx={{ gridColumn: "span 2" }}>
              <CheckboxWithText
                checked={!!existing || isOtherActive}
                disabled={isDisabled}
                error={error}
                isTextActive={isOtherActive}
                label=""
                onCheckChange={(checked) => {
                  if (!checked) {
                    onChange(value.filter((v) => v.type !== enumValue));
                  } else {
                    onChange([...value, { type: enumValue, otherText: "" }]);
                  }
                }}
                onTextChange={(text) => {
                  onChange(value.map((v) => (v.type === enumValue ? { ...v, otherText: text } : v)));
                }}
                textLabel="Other"
                textValue={existing?.otherText ?? ""}
              />
            </Box>
          );
        }

        return (
          <FormControlLabel
            key={enumValue}
            control={
              <Checkbox
                checked={!!existing}
                disabled={isDisabled}
                onChange={(e) => {
                  if (!e.target.checked) {
                    onChange(value.filter((v) => v.type !== enumValue));
                  } else {
                    onChange([...value, { type: enumValue }]);
                  }
                }}
              />
            }
            label={label}
          />
        );
      })}
      <FieldError error={error} show={!value?.length} />
    </Stack>
  );
};

export default CredentialsEdit;
